document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(function(mutations) {
    // Change "Products" header to "Advisors"
    const productHeaders = document.querySelectorAll('.aa-SourceHeaderTitle');
    productHeaders.forEach(function(header) {
      if (header.textContent.toLowerCase().includes('product')) {
        header.textContent = header.textContent.replace(/products/i, 'Advisors');
      }
    });
    
    // Change search placeholder
    const searchInputs = document.querySelectorAll('.ais-SearchBox-input');
    searchInputs.forEach(function(input) {
      if (input.placeholder && input.placeholder.toLowerCase().includes('product')) {
        input.placeholder = input.placeholder.replace(/products/i, 'advisors');
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});